import { Checkbox, HelperText, Surface, Txt, validators } from '@vst/beam';

type ExplicitInformedConsentProps = {
  id: string;
  label: string;
  isChecked: boolean;
  onChange: () => void;
  hasError: boolean;
  errorMessage: string;
  disclosureText: string[];
  consentRef?: React.RefObject<HTMLInputElement>;
};

const ExplicitInformedConsent = ({
  id,
  label,
  isChecked,
  onChange,
  hasError,
  errorMessage,
  disclosureText,
  consentRef,
}: ExplicitInformedConsentProps) => {
  return (
    <Surface>
      {disclosureText?.map((text, index) => (
        <Txt
          component="p"
          key={`disclosure-text-${index}`}
          variant="bodySmallRegular"
          mb="24px"
        >
          {splitLineIfSeparator(text).map((line, lineIndex) => (
            <Txt
              key={`line-${index}-${lineIndex}`}
              component="span"
              variant="bodySmallRegular"
              mb="4px"
              style={{ display: 'block' }}
            >
              {line}
            </Txt>
          ))}
        </Txt>
      ))}

      <Surface variant={'secondary'} p={'16px'} radius={'8px'}>
        <Checkbox
          required
          id={id}
          name={id}
          label={label}
          checked={isChecked}
          onChange={onChange}
          error={hasError}
          validationRules={[
            validators.required({
              message: errorMessage,
            }),
          ]}
          ref={consentRef}
        />

        {hasError && (
          <HelperText
            helpMessage={errorMessage}
            state={'error'}
            style={{ paddingTop: '4px' }}
          />
        )}
      </Surface>
    </Surface>
  );
};

export default ExplicitInformedConsent;

function splitLineIfSeparator(line: string): string[] {
  return line.includes('|') ? line.split('|') : [line];
}
